import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { FORGOT_PASSWORD } from "../actions";

export const forgetPasswordLoadingSelector = createLoadingSelector([FORGOT_PASSWORD]);
export const forgetPasswordErrorSelector = createErrorSelector([FORGOT_PASSWORD]);